// Use environment variable in production, fallback to relative URL in development
export const API_URL = process.env.REACT_APP_API_URL || "";
